var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"gltf-row",attrs:{"element-loading-background":"rgba(11,39,64,0)"}},[_c('div',{ref:"scene",staticClass:"scene",staticStyle:{"height":"260px","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }